import { _AuthApi } from "api/auth";
import { Navigate, useLocation } from "react-router-dom";

const ShouldBeLogged = ({ children }) => {
  let location = useLocation();

  if (!_AuthApi.getAccessToken()) {
    return <Navigate to="/" state={location.pathname} replace />;
  }
  return children;
};

export default ShouldBeLogged